<template>
  <FavoriteDropDown
    v-bind="$attrs"
    :content-style="dropdownCssVariables"
    :icons="icons"
    input-placeholder="Новая папка"
    @open-menu="$emit('open-favorite-menu', $event)"
    @close-menu="$emit('close-favorite-menu', $event)"
    @delete-from-favorites="(...args) => $emit('favorite-delete', ...args)"
    @create-folder-and-add="(...args) => $emit('favorite-create-folder-and-add', ...args)"
    @create-folder-and-transfer="(...args) => $emit('favorite-create-folder-and-transfer', ...args)"
    @transfer-to-folder="(...args) => $emit('favorite-transfer-to-folder', ...args)"
    @add-to-folder="(...args) => $emit('favorite-add-to-folder', ...args)"
    @deferred="(...args) => $emit('favorite-deferred', ...args)"
  >
    <template #default="{ active }">
      <SvgAsset
        :style="iconCssVariables"
        class="icon"
        :class="{ active }"
        :content="favoriteIconContent"
      />
    </template>
  </FavoriteDropDown>
</template>

<script lang="ts" setup>
  import type { IconsContent } from '@devhacker/shared/components/favorite/types';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import FavoriteDropDown from '@devhacker/shared/components/favorite/FavoriteDropDown.vue';

  import favoriteIconContent from './favorite.svg?raw';
  import addIconContent from './add.svg?raw';
  import deleteIconContent from './delete.svg?raw';
  import checkIconContent from './tick-big.svg?raw';
  import smallCheckIconContent from './tick.svg?raw';
  import type { PropType } from 'vue';

  const props = defineProps({
    iconCssVariables: {
      type: Object as PropType<Record<string, string>>,
      default: null,
    },
    dropdownCssVariables: {
      type: Object as PropType<Record<string, string>>,
      default: null,
    },
  });

  // Define emits
  const emit = defineEmits([
    'open-favorite-menu',
    'close-favorite-menu',
    'favorite-delete',
    'favorite-create-folder-and-add',
    'favorite-create-folder-and-transfer',
    'favorite-transfer-to-folder',
    'favorite-add-to-folder',
    'favorite-deferred',
  ]);

  const iconCssVariables = computed(() => ({
    '--favorite-icon-color': '#969698',
    '--favorite-icon-hover-color': 'black',
    '--favorite-icon-active-color': 'var(--main-color)',
    ...(props.iconCssVariables ?? {}),
  }));

  const dropdownCssVariables = computed(() => ({
    '--favorite-drop-down-accent-color': 'var(--main-color-2)',
    '--favorite-drop-down-accent-darker-color': 'var(--hover-color-2)',
    '--favorite-drop-down-accent-lighter-color': '#E1EAFD',
    '--favorite-drop-down-spacer-color': '#E7E7E7',
    '--favorite-drop-down-text-color': '#000000',
    '--favorite-drop-down-placeholder-color': '#969698',
    ...(props.dropdownCssVariables ?? {}),
  }));

  const icons: IconsContent = {
    add: addIconContent,
    delete: deleteIconContent,
    check: checkIconContent,
    smallCheck: smallCheckIconContent,
  };
</script>

<style lang="scss" scoped>
  .favorite-drop-down {
  }

  .icon {
    cursor: pointer;
    box-sizing: content-box;
    padding: 6px;
    margin: -6px;
  }

  .icon:not(.active) {
    color: var(--favorite-icon-color);

    @include hover {
      color: var(--favorite-icon-hover-color);
    }
  }

  .active {
    color: var(--favorite-icon-active-color);

    @include hover {
      color: var(--favorite-icon-hover-color);
    }

    :deep(path) {
      fill: var(--favorite-icon-active-color);
    }
  }
</style>
